export const PLAN_GRID_CURRENCY_KEY = 'planGridCurrency'

export default PLAN_GRID_CURRENCY_KEY
